import {EventEmitter, Injectable, Output} from '@angular/core';
import {ConfService} from './conf.service';
import {Loggedin} from './authFilter/platformCentralAuth';
import {MatDialog} from '@angular/material';
import {LeftpanelComponent} from './leftpanel/leftpanel.component';
import {WebsocketService} from './websocket.service';
import {environment} from '../environments/environment';
import {interval} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AlertService {

  @Output() alertRefreshListener: EventEmitter<any> = new EventEmitter();

  partner = localStorage.getItem('partner');
  account = localStorage.getItem('account');
  alertsData = [];

  isSubscriptionError = false;
  isRetrieveError = false;

  isRetrieveFirstTimeLoading = true;

  refreshSubscription: any;

  constructor(private confPost: ConfService,
              public websocketService: WebsocketService) {
    this.refreshEventSetup();
  }


  refreshEventSetup() {
    this.setPartnerAccountData();
    if (this.refreshSubscription === undefined) {
      this.refreshSubscription = this.alertRefreshListener.subscribe(
          (eventObject) => {
            if (eventObject && eventObject.action === 'init') { // to initialize both subscription and data access
              this.subscribeToAlertTopics();
              this.retrieveExistingAlerts();
            } else if (eventObject && eventObject.action === 'subscription') {
              this.subscribeToAlertTopics();
            } else if (eventObject && eventObject.action === 'data') {
              this.retrieveExistingAlerts();
            }

          }
      );
    }
  }

  subscribeToAlertTopics() {
    this.setPartnerAccountData();
    const payload = {
      intent: 'alert-topics',
      user: this.getEmail(),
      partner: this.partner,
      account: this.account
    };

    this.confPost.postCoreApi(environment.coreAPI.alerts.name, environment.coreAPI.alerts.version, payload).subscribe(data => {
      let res: any;
      res = data;
      this.isSubscriptionError = false;
      let count = 0;
      const webSocketSubscription = interval(1000).subscribe((async x => {
        if (this.websocketService.isOpen()) {
          webSocketSubscription.unsubscribe();

          const topics = [];
          for (const val of res['items']) {
            topics.push(val['topic']);
          }
          this.subscribeNotificationTopics(topics);
        }
        if (count === 15) {
          webSocketSubscription.unsubscribe();
        }
        count++;
      }));

    }, error => {
      this.isSubscriptionError = true;
      // this.platform.handleErrorGracefully(error, 'Error while getting topics.');
    });

  }

  subscribeNotificationTopics(topics) {
    this.websocketService.addNotificationsListener(topics).subscribe(data => {
      if (data) {
        const msg = JSON.parse(data.body);
        this.alertsData.unshift((msg));
      }
    });

  }

  retrieveExistingAlerts() {
    this.setPartnerAccountData();
    const payload = {
      intent: 'alerts',
      significance: 'compose',
      user: this.getEmail(),
      partner: this.partner,
      account: this.account,
      pkey: this.getPartnerKey()
    };

    this.confPost.postCoreApi(environment.coreAPI.alertsInfo.name, environment.coreAPI.alertsInfo.version, payload).subscribe(data => {
      let res: any;
      res = data;
      this.isRetrieveError = false;
      this.isRetrieveFirstTimeLoading = false;

      const alerts = res['items'];

      if (data && alerts.data) {
        for (const val of alerts.data) {
          this.alertsData.push(val);
        }
      }

    }, error => {
      this.isRetrieveError = true;
      this.isRetrieveFirstTimeLoading = false;
    });
  }

  getEmail() {
    return localStorage.getItem('signInEmail');
  }

  getPartnerKey() {
    return localStorage.getItem('partnerKey');
  }

  setPartnerAccountData() {
    this.partner = localStorage.getItem('partner');
    this.account = localStorage.getItem('account');
  }
}
